import React from 'react';
import {Message} from "semantic-ui-react";
import {PaymentDetails} from "./PaymentDetailsContainer";


const StripePaymentError = ({strings, paymentMethod}) => {
    const { stripePaymentError } = PaymentDetails.useContainer();

    return (
        <>
            { stripePaymentError &&
            <Message style={{border: "none", borderRadius: 0}} negative>
                <b>{strings.paymentIssue}</b> { strings.thereWasAnIssue.replace("payment_method", paymentMethod.toLowerCase())}
            </Message>
            }
        </>
    );
}

export default StripePaymentError;